import { createQueryKeys } from "@lukemorales/query-key-factory";
import { getNavigation } from "@/api/actions/navigation-actions";

export const navigationQuery = createQueryKeys("navigation", {
  // Get all company and resource navigation link
  getNavigation: () => ({
    queryKey: [{}],
    queryFn: () => getNavigation({ populate: "deep,5" }),
  }),
});
